import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import type {
  CreateSegmentRequest,
  Segment,
} from '@/types/models/segments/segment';
import {createSegment} from '@/api/fetchers/segments';
import {SEGMENTS_QUERY_KEY} from '@/hooks/queries/use-segments-query';

export default function useCreateSegmentMutation() {
  return useMutation<Segment, Error, CreateSegmentRequest>({
    mutationKey: [SEGMENTS_QUERY_KEY, 'create'],
    mutationFn: createSegment,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [SEGMENTS_QUERY_KEY]});
    },
  });
}
